'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetTypicalResponseTime = undefined;

var _reselect = require('reselect');

var _getTypicalResponseTime = require('conversations-schema/operators/widget-data/getTypicalResponseTime');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var getWidgetTypicalResponseTime = exports.getWidgetTypicalResponseTime = (0, _reselect.createSelector)([_getWidgetData.getWidgetData], _getTypicalResponseTime.getTypicalResponseTime);


//////////////////
// WEBPACK FOOTER
// ./js/typical-response-time/selectors/getWidgetTypicalResponseTime.js
// module id = 395
// module chunks = 2 3